"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseSsaiManager = void 0;
var player_base_1 = require("@24i/player-base");
var player_plugin_ads_1 = require("@24i/player-plugin-ads");
var utils_1 = require("../utils");
var AD_START_TOLERANCE = 2000;
var BaseSsaiManager = (function (_super) {
    __extends(BaseSsaiManager, _super);
    function BaseSsaiManager(player) {
        var _this = _super.call(this) || this;
        _this.advertisements = [];
        _this.currentIndex = -1;
        _this.currentAdvertisement = null;
        _this.currentStarted = false;
        _this.previousTime = -1;
        _this.shouldSnapback = false;
        _this.snapbackType = player_base_1.SeekType.CURRENT_TIME;
        _this.startupAdvertisement = false;
        _this.continuousPlayback = false;
        _this.hasSeeked = true;
        _this.player = player;
        _this.onLoadedMetadata = _this.onLoadedMetadata.bind(_this);
        _this.onTimeUpdate = _this.onTimeUpdate.bind(_this);
        _this.onSeeked = _this.onSeeked.bind(_this);
        _this.onMutedChanged = _this.onMutedChanged.bind(_this);
        _this.onPause = _this.onPause.bind(_this);
        _this.onPlay = _this.onPlay.bind(_this);
        return _this;
    }
    BaseSsaiManager.prototype.getCurrentTime = function (seekTime, seekType) {
        var _a = this.player, live = _a.live, timeshiftRange = _a.timeshiftRange;
        if (seekType === player_base_1.SeekType.TIMESHIFT && live && timeshiftRange) {
            return timeshiftRange.end + seekTime;
        }
        if (seekType === player_base_1.SeekType.UTC && this.utcOffset) {
            return seekTime - this.utcOffset;
        }
        return seekTime;
    };
    BaseSsaiManager.prototype.getUtcTime = function (seekTime, seekType) {
        var _a = this.player, live = _a.live, timeshiftRange = _a.timeshiftRange;
        if (typeof seekTime !== 'number')
            return undefined;
        if (seekType === player_base_1.SeekType.UTC)
            return seekTime;
        if (!live)
            return undefined;
        var adjustedTime = seekTime;
        if (this.utcOffset) {
            adjustedTime += this.utcOffset;
        }
        if (seekType === player_base_1.SeekType.TIMESHIFT && timeshiftRange) {
            adjustedTime += timeshiftRange.end;
        }
        return adjustedTime;
    };
    BaseSsaiManager.prototype.getContentTime = function (mediaTime) {
        return utils_1.getContentTime(this.advertisements, mediaTime);
    };
    BaseSsaiManager.prototype.getMediaTime = function (contentTime) {
        return utils_1.getMediaTime(this.advertisements, contentTime);
    };
    Object.defineProperty(BaseSsaiManager.prototype, "isPlayingClientSide", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseSsaiManager.prototype, "paused", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    BaseSsaiManager.prototype.play = function () {
    };
    BaseSsaiManager.prototype.pause = function () {
    };
    Object.defineProperty(BaseSsaiManager.prototype, "currentTime", {
        get: function () {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseSsaiManager.prototype, "duration", {
        get: function () {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    BaseSsaiManager.prototype.load = function (source) {
        this.player.addEventListener('loadedmetadata', this.onLoadedMetadata);
        this.player.addEventListener('timeupdate', this.onTimeUpdate);
        this.player.addEventListener('seeked', this.onSeeked);
        this.player.addEventListener('pause', this.onPause);
        this.player.addEventListener('play', this.onPlay);
        this.player.addEventListener('mutedchanged', this.onMutedChanged);
        this.utcOffset = undefined;
        this.updateAdvertisements();
        return Promise.resolve(source);
    };
    BaseSsaiManager.prototype.updateAdvertisements = function () {
        this.advertisements = this.getAdvertisements();
        if (this.currentIndex >= 0 &&
            this.currentIndex < this.advertisements.length) {
            this.currentAdvertisement = this.advertisements[this.currentIndex];
        }
        this.onTimeUpdate();
        this.player.events.triggerEvent('adbreaksrescheduled', {
            loadedAdBreaksOffsets: this.adBreaks,
        });
    };
    BaseSsaiManager.prototype.seek = function (activeSeek) {
        var _a;
        var seekOptions = (_a = activeSeek.options) !== null && _a !== void 0 ? _a : {};
        var fromAdjustment = this.resolveSeekFrom(activeSeek);
        var toAdjustment = this.resolveSeekTo(activeSeek);
        var over = this.resolveSeekOver(fromAdjustment, toAdjustment);
        var blockedSeek = this.handleBlockedSeek(activeSeek, fromAdjustment, toAdjustment);
        if (blockedSeek)
            return blockedSeek;
        var finalAdjustment = this.adjustSeek(fromAdjustment, toAdjustment, over, seekOptions);
        return this.processFinalAdjustment(activeSeek, seekOptions, fromAdjustment, toAdjustment, finalAdjustment);
    };
    BaseSsaiManager.prototype.resolveSeekFrom = function (activeSeek) {
        var _a;
        var fromTime = (_a = activeSeek.from) !== null && _a !== void 0 ? _a : this.player.currentTime;
        var fromAdvertisement = this.advertisements.find(function (advertisement) {
            var _a;
            return advertisement.start <= fromTime &&
                fromTime < ((_a = advertisement.earlyEnd) !== null && _a !== void 0 ? _a : advertisement.end);
        });
        return {
            time: fromTime,
            advertisement: fromAdvertisement,
        };
    };
    BaseSsaiManager.prototype.resolveSeekTo = function (activeSeek) {
        var _a;
        var toTime = (_a = activeSeek.currentTime) !== null && _a !== void 0 ? _a : this.player.currentTime;
        var toAdvertisement = this.advertisements.find(function (advertisement) {
            var _a;
            return advertisement.start <= toTime &&
                toTime < ((_a = advertisement.earlyEnd) !== null && _a !== void 0 ? _a : advertisement.end);
        });
        return {
            time: toTime,
            advertisement: toAdvertisement,
        };
    };
    BaseSsaiManager.prototype.resolveSeekOver = function (fromAdjustment, toAdjustment) {
        var fromTime = fromAdjustment.time;
        var toTime = toAdjustment.time;
        return this.advertisements.filter(function (advertisement) {
            var _a;
            return advertisement.start < toTime &&
                ((_a = advertisement.earlyEnd) !== null && _a !== void 0 ? _a : advertisement.end) >= fromTime;
        });
    };
    BaseSsaiManager.prototype.allowSnapback = function () {
        var _a, _b;
        return (_b = (_a = this.player.seekingRestrictions) === null || _a === void 0 ? void 0 : _a.advertisementSnapback) !== null && _b !== void 0 ? _b : true;
    };
    BaseSsaiManager.prototype.handleBlockedSeek = function (activeSeek, fromAdjustment, toAdjustment) {
        if (fromAdjustment.time !== toAdjustment.time)
            return null;
        var seekWasBlocked = activeSeek.seekingRestricted ||
            activeSeek.unskippableAdvertisement ||
            activeSeek.forcedAdvertisement;
        if (seekWasBlocked && this.allowSnapback()) {
            this.snapbackTime = activeSeek.time;
            this.snapbackType = activeSeek.type;
        }
        return {};
    };
    BaseSsaiManager.prototype.processFinalAdjustment = function (activeSeek, seekOptions, fromAdjustment, toAdjustment, finalAdjustment) {
        var _a, _b;
        if (finalAdjustment.time === toAdjustment.time) {
            this.snapbackTime = undefined;
            this.hasSeeked = true;
            this.continuousPlayback = false;
            return {};
        }
        if (toAdjustment.advertisement &&
            toAdjustment.advertisement === finalAdjustment.advertisement) {
            this.snapbackTime = undefined;
        }
        else if (this.allowSnapback()) {
            this.snapbackTime = activeSeek.time;
            this.snapbackType = activeSeek.type;
        }
        if (seekOptions.startupPosition) {
            this.startupAdvertisement = true;
        }
        if (finalAdjustment.time !== fromAdjustment.time) {
            this.continuousPlayback = true;
            return {
                currentTime: finalAdjustment.time,
                forcedAdvertisement: true,
                adBreakOffset: (_a = finalAdjustment.advertisement) === null || _a === void 0 ? void 0 : _a.start,
            };
        }
        else {
            return {
                currentTime: finalAdjustment.time,
                unskippableAdvertisement: true,
                adBreakOffset: (_b = finalAdjustment.advertisement) === null || _b === void 0 ? void 0 : _b.start,
            };
        }
    };
    BaseSsaiManager.prototype.adjustSeek = function (from, to, over, seekOptions) {
        var _a;
        var seekingRestrictions = this.player.seekingRestrictions;
        var advertisementSeek = (_a = seekingRestrictions === null || seekingRestrictions === void 0 ? void 0 : seekingRestrictions.advertisementSeek) !== null && _a !== void 0 ? _a : player_base_1.AdvertisementSeek.STRICT;
        var nonAdjustableSeekAdjustment = this.detectNonAdvertisableSeek(from, to, seekOptions, advertisementSeek);
        if (nonAdjustableSeekAdjustment)
            return nonAdjustableSeekAdjustment;
        var advertisementFilter = this.resolveAdvertisementFilter(seekingRestrictions);
        var advertisementSelection = this.resolveAdvertisementSelection(seekingRestrictions, seekOptions);
        var forcedAdvertisement = this.resolveAdvertisementToForce(from, to, over, advertisementFilter, advertisementSelection);
        if (seekOptions.advertisementSnapback &&
            to.advertisement &&
            (!forcedAdvertisement || forcedAdvertisement === to.advertisement)) {
            return {
                time: to.advertisement.end,
                advertisement: to.advertisement,
            };
        }
        return this.buildFinalSeekAdjustment(from, to, forcedAdvertisement, advertisementSeek);
    };
    BaseSsaiManager.prototype.detectNonAdvertisableSeek = function (from, to, seekOptions, advertisementSeek) {
        if (to.time === from.time)
            return to;
        if (to.time < from.time) {
            if (seekOptions.suppressAdvertisements)
                return to;
            if (from.advertisement && !from.advertisement.canRestart)
                return from;
            if (!to.advertisement)
                return to;
            if (advertisementSeek === player_base_1.AdvertisementSeek.UNRESTRICTED)
                return to;
            if (advertisementSeek === player_base_1.AdvertisementSeek.SKIPPABLE &&
                Number.isFinite(to.advertisement.skipOffset) &&
                to.advertisement.skipOffset <= to.time)
                return to;
            return {
                advertisement: to.advertisement,
                time: to.advertisement.start,
            };
        }
        return null;
    };
    BaseSsaiManager.prototype.resolveAdvertisementFilter = function (seekingRestrictions) {
        var _a;
        return ((_a = seekingRestrictions === null || seekingRestrictions === void 0 ? void 0 : seekingRestrictions.advertisementFilter) !== null && _a !== void 0 ? _a : player_base_1.ITimelineEventPlayed.UNPLAYED);
    };
    BaseSsaiManager.prototype.resolveAdvertisementSelection = function (seekingRestrictions, seekOptions) {
        var _a;
        var advertisementSelection = (_a = seekingRestrictions === null || seekingRestrictions === void 0 ? void 0 : seekingRestrictions.advertisementSelection) !== null && _a !== void 0 ? _a : player_base_1.AdvertisementSelection.LAST;
        if (seekOptions.suppressAdvertisements) {
            advertisementSelection = player_base_1.AdvertisementSelection.NONE;
        }
        else if (seekOptions.startupPosition) {
            advertisementSelection = player_base_1.AdvertisementSelection.ALL;
        }
        else if (seekOptions.advertisementSnapback &&
            advertisementSelection !== player_base_1.AdvertisementSelection.ALL) {
            advertisementSelection = player_base_1.AdvertisementSelection.NONE;
        }
        return advertisementSelection;
    };
    BaseSsaiManager.prototype.resolveAdvertisementToForce = function (from, to, over, advertisementFilter, advertisementSelection) {
        var forceableAdvertisements = __spreadArray(__spreadArray([
            from.advertisement
        ], over), [
            to.advertisement,
        ]);
        return utils_1.applyAdvertisementSelection(advertisementSelection !== null && advertisementSelection !== void 0 ? advertisementSelection : player_base_1.AdvertisementSelection.LAST, forceableAdvertisements.filter(function (advertisment) {
            return utils_1.applyAdvertisementFilter(advertisementFilter !== null && advertisementFilter !== void 0 ? advertisementFilter : player_base_1.ITimelineEventPlayed.UNPLAYED, advertisment === null || advertisment === void 0 ? void 0 : advertisment.played);
        }));
    };
    BaseSsaiManager.prototype.buildFinalSeekAdjustment = function (from, to, forcedAdvertisement, advertisementSeek) {
        if (!forcedAdvertisement) {
            if (!to.advertisement)
                return to;
            if (advertisementSeek === player_base_1.AdvertisementSeek.UNRESTRICTED)
                return to;
            if (advertisementSeek === player_base_1.AdvertisementSeek.SKIPPABLE &&
                Number.isFinite(to.advertisement.skipOffset) &&
                to.advertisement.skipOffset <= to.time)
                return to;
            return {
                advertisement: to.advertisement,
                time: to.advertisement.end,
            };
        }
        if (forcedAdvertisement === from.advertisement)
            return from;
        return {
            time: forcedAdvertisement.start,
            advertisement: forcedAdvertisement,
        };
    };
    BaseSsaiManager.prototype.onLoadedMetadata = function () {
        var _a = this.player, live = _a.live, currentTime = _a.currentTime;
        if (!live) {
            this.utcOffset = undefined;
        }
        else {
            var currentTimeDate = this.player.getUTCTimestamp(currentTime);
            if (!currentTimeDate) {
                this.utcOffset = undefined;
            }
            else {
                this.utcOffset = currentTimeDate.getTime() - currentTime;
            }
        }
        this.updateAdvertisements();
    };
    BaseSsaiManager.prototype.onSeeked = function (event) {
        if (event.from === event.currentTime)
            return;
        if (event.forcedAdvertisement)
            return;
        if (event.type === player_base_1.SeekType.TIMESHIFT && event.time === 0) {
            var _a = this.player, live = _a.live, timeshiftRange = _a.timeshiftRange;
            if (live && timeshiftRange.start === timeshiftRange.end)
                return;
        }
        this.hasSeeked = true;
    };
    BaseSsaiManager.prototype.onPlay = function () {
        var currentAdvertisement = this.currentAdvertisement;
        if (!currentAdvertisement)
            return;
        this.onAdTracking(currentAdvertisement, 'resume');
    };
    BaseSsaiManager.prototype.onPause = function () {
        var currentAdvertisement = this.currentAdvertisement;
        if (!currentAdvertisement)
            return;
        this.onAdTracking(currentAdvertisement, 'pause');
    };
    BaseSsaiManager.prototype.onMutedChanged = function () {
        var _a = this, player = _a.player, currentAdvertisement = _a.currentAdvertisement;
        if (!currentAdvertisement || !player)
            return;
        this.onAdTracking(currentAdvertisement, player.muted ? 'mute' : 'unmute');
    };
    BaseSsaiManager.prototype.onTimeUpdate = function () {
        var _a;
        var _b = this.player, currentTime = _b.currentTime, seeking = _b.seeking;
        if (seeking)
            return;
        if (this.previousTime === currentTime)
            return;
        var previousIndex = this.currentIndex;
        var newIndex = this.advertisements.findIndex(function (advertisement) {
            var _a;
            return advertisement.start <= currentTime &&
                currentTime < ((_a = advertisement.earlyEnd) !== null && _a !== void 0 ? _a : advertisement.end);
        });
        var previousAdvertisement = (_a = this.advertisements[previousIndex]) !== null && _a !== void 0 ? _a : this.currentAdvertisement;
        var newAdvertisement = this.advertisements[newIndex];
        var previousStarted = this.currentStarted;
        var _c = this, hasSeeked = _c.hasSeeked, previousTime = _c.previousTime;
        this.shouldSnapback = false;
        this.currentIndex = newIndex;
        this.currentAdvertisement = newAdvertisement;
        this.previousTime = currentTime;
        this.hasSeeked = false;
        if (previousTime < 0) {
            this.continuousPlayback = true;
            hasSeeked = false;
        }
        this.maybeReportPreviousAdvertisement(currentTime, previousTime, hasSeeked, newAdvertisement, previousAdvertisement, previousStarted);
        this.maybeReportNewAdvertisement(currentTime, previousTime, hasSeeked, newAdvertisement, previousAdvertisement, previousStarted);
        this.maybeSnapback(currentTime);
    };
    BaseSsaiManager.prototype.maybeReportPreviousAdvertisement = function (currentTime, previousTime, hasSeeked, newAdvertisement, previousAdvertisement, previousStarted) {
        var _a;
        if (!previousAdvertisement)
            return;
        var suppressSnapback = false;
        if (previousStarted || !previousAdvertisement.dataIncomplete) {
            var duration = ((_a = previousAdvertisement.earlyEnd) !== null && _a !== void 0 ? _a : previousAdvertisement.end) -
                previousAdvertisement.start;
            var from = Math.max(0, previousTime - previousAdvertisement.start);
            var to = Math.min(duration, currentTime - previousAdvertisement.start);
            var seekedOut = hasSeeked && previousAdvertisement !== newAdvertisement;
            if (hasSeeked) {
                if (currentTime !== previousTime)
                    this.continuousPlayback = false;
                if (seekedOut) {
                    to = from;
                    suppressSnapback = true;
                }
            }
            if (from > to) {
                suppressSnapback = true;
            }
            this.onAdProgress(previousAdvertisement, from, to, duration, seekedOut);
        }
        if (!newAdvertisement) {
            this.onAdBreakEnded();
            this.shouldSnapback =
                typeof this.snapbackTime === 'number' && !suppressSnapback;
        }
    };
    BaseSsaiManager.prototype.maybeReportNewAdvertisement = function (currentTime, previousTime, hasSeeked, newAdvertisement, previousAdvertisement, previousStarted) {
        var _a;
        if (!newAdvertisement)
            return;
        if (!previousAdvertisement) {
            this.onAdBreakStarted(newAdvertisement.adBreak);
        }
        if (newAdvertisement !== previousAdvertisement) {
            this.currentStarted = false;
        }
        if (newAdvertisement.dataIncomplete)
            return;
        if (newAdvertisement !== previousAdvertisement || !previousStarted) {
            this.currentStarted = true;
            this.onAdStarted(newAdvertisement.ad);
            var duration = ((_a = newAdvertisement.earlyEnd) !== null && _a !== void 0 ? _a : newAdvertisement.end) -
                newAdvertisement.start;
            var from = Math.max(0, previousTime - newAdvertisement.start);
            var to = Math.min(duration, currentTime - newAdvertisement.start);
            if (hasSeeked && to >= AD_START_TOLERANCE) {
                this.continuousPlayback = false;
                from = to;
            }
            this.onAdProgress(newAdvertisement, from, to, duration, false);
        }
    };
    BaseSsaiManager.prototype.maybeSnapback = function (currentTime) {
        if (this.shouldSnapback && this.allowSnapback()) {
            var _a = this, snapbackTime = _a.snapbackTime, startupAdvertisement = _a.startupAdvertisement;
            var seekOptions = {
                advertisementSnapback: true,
                startupPosition: startupAdvertisement,
                suppressAdvertisements: startupAdvertisement,
            };
            this.snapbackTime = undefined;
            this.startupAdvertisement = false;
            var resolvedTime_1 = this.player.getStreamTime(snapbackTime, this.snapbackType);
            var resolvedAdvertisement = this.advertisements.find(function (advertisement) {
                return advertisement.start <= resolvedTime_1 &&
                    resolvedTime_1 < advertisement.end;
            });
            if (!resolvedAdvertisement || resolvedTime_1 >= currentTime) {
                this.player.seek(snapbackTime, this.snapbackType, seekOptions);
            }
        }
    };
    BaseSsaiManager.prototype.onAdProgress = function (advertisement, from, to, duration, seekedOut) {
        if (advertisement.played === player_base_1.ITimelineEventPlayed.UNPLAYED) {
            this.onAdTracking(advertisement, 'impression');
        }
        if (from === 0) {
            this.continuousPlayback = true;
            this.onAdTracking(advertisement, 'start');
        }
        else if (advertisement.played === player_base_1.ITimelineEventPlayed.UNPLAYED &&
            this.continuousPlayback) {
            this.onAdTracking(advertisement, 'start');
        }
        this.processPlayedState(advertisement, from, to, duration, seekedOut);
        if (from > to) {
            this.onAdTracking(advertisement, 'rewind');
        }
        else {
            if (to < duration) {
                this.onAdTracking(advertisement, 'progress');
            }
            this.processContinuousPlayback(advertisement, from, to, duration, seekedOut);
        }
    };
    BaseSsaiManager.prototype.processPlayedState = function (advertisement, from, to, duration, seekedOut) {
        var _a;
        var skipOffsetRelative = duration;
        if (typeof advertisement.skipOffset === 'number') {
            skipOffsetRelative = advertisement.skipOffset - advertisement.start;
        }
        var canSkip = this.resolveCanSkip(advertisement, to);
        var persistCanSkip = ((_a = this.player.seekingRestrictions) === null || _a === void 0 ? void 0 : _a.advertisementSkippablePersists) !==
            false;
        if (seekedOut) {
            if (canSkip && from < to) {
                advertisement.played = player_base_1.ITimelineEventPlayed.SKIPPED;
                this.onAdTracking(advertisement, 'skip');
            }
            else {
                advertisement.played = player_base_1.ITimelineEventPlayed.UNPLAYED;
            }
        }
        else if (to < skipOffsetRelative) {
            advertisement.played = canSkip
                ? player_base_1.ITimelineEventPlayed.PLAYING_SKIPPABLE
                : player_base_1.ITimelineEventPlayed.PLAYING_UNSKIPPABLE;
        }
        else if (to >= duration) {
            advertisement.canSkip = persistCanSkip;
            advertisement.played = this.continuousPlayback
                ? player_base_1.ITimelineEventPlayed.PLAYED
                : player_base_1.ITimelineEventPlayed.SKIPPED;
        }
        else if (from < skipOffsetRelative ||
            advertisement.played !== player_base_1.ITimelineEventPlayed.PLAYING_SKIPPABLE) {
            advertisement.canSkip = persistCanSkip;
            advertisement.played = player_base_1.ITimelineEventPlayed.PLAYING_SKIPPABLE;
            this.onAdSkippable();
        }
    };
    BaseSsaiManager.prototype.resolveCanSkip = function (advertisement, time) {
        var canSkip = advertisement.canSkip, skipOffset = advertisement.skipOffset;
        return canSkip || (Number.isFinite(skipOffset) && skipOffset <= time);
    };
    BaseSsaiManager.prototype.processContinuousPlayback = function (advertisement, from, to, duration, seekedOut) {
        if (this.continuousPlayback && !seekedOut) {
            var fromFraction = from / duration;
            var toFraction = to / duration;
            if (fromFraction < 0.25 && toFraction >= 0.25) {
                this.onAdTracking(advertisement, 'firstQuartile');
            }
            if (fromFraction < 0.5 && toFraction >= 0.5) {
                this.onAdTracking(advertisement, 'midpoint');
            }
            if (fromFraction < 0.75 && toFraction >= 0.75) {
                this.onAdTracking(advertisement, 'thirdQuartile');
            }
            if (fromFraction < 1 && toFraction >= 1) {
                this.onAdTracking(advertisement, 'complete');
            }
        }
    };
    BaseSsaiManager.prototype.onAdBreakStarted = function (adBreak) {
        this.player.events.triggerEvent('adbreakstarted', adBreak);
    };
    BaseSsaiManager.prototype.onAdStarted = function (ad) {
        this.player.events.triggerEvent('adstarted', ad);
    };
    BaseSsaiManager.prototype.onAdTracking = function (advertisement, vastTrackingEvent) {
        if (vastTrackingEvent === 'progress')
            return;
        var eventPayload = {
            trackingEvent: vastTrackingEvent,
            adBreak: advertisement.adBreak,
            ad: advertisement.ad,
        };
        this.player.events.triggerEvent('adtracking', eventPayload);
    };
    BaseSsaiManager.prototype.onAdBreakEnded = function () {
        this.player.events.triggerEvent('adbreakended');
    };
    BaseSsaiManager.prototype.onAdSkippable = function () {
        this.player.events.triggerEvent('adskippable');
    };
    BaseSsaiManager.prototype.setMetadata = function (sourceMetadata) {
        this.updateAdvertisements();
    };
    Object.defineProperty(BaseSsaiManager.prototype, "currentAdBreak", {
        get: function () {
            var _a;
            return ((_a = this.currentAdvertisement) === null || _a === void 0 ? void 0 : _a.adBreak) || null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseSsaiManager.prototype, "currentAd", {
        get: function () {
            var _a;
            return ((_a = this.currentAdvertisement) === null || _a === void 0 ? void 0 : _a.ad) || null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseSsaiManager.prototype, "adBreaks", {
        get: function () {
            return this.advertisements.map(function (advertisement) { return advertisement.start; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseSsaiManager.prototype, "timelineEvents", {
        get: function () {
            return this.advertisements;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseSsaiManager.prototype, "canSkipAd", {
        get: function () {
            if (!this.currentAdvertisement)
                return false;
            return this.resolveCanSkip(this.currentAdvertisement, this.player.currentTime);
        },
        enumerable: false,
        configurable: true
    });
    BaseSsaiManager.prototype.skipAd = function () {
        if (this.currentIndex < 0)
            return;
        var currentAdvertisement = this.advertisements[this.currentIndex];
        var canSkip = this.resolveCanSkip(this.currentAdvertisement, this.player.currentTime);
        if (!canSkip)
            return;
        currentAdvertisement.played = player_base_1.ITimelineEventPlayed.SKIPPED;
        this.onAdTracking(currentAdvertisement, 'skip');
        this.continuousPlayback = undefined;
        var _a = this, snapbackTime = _a.snapbackTime, snapbackType = _a.snapbackType;
        if (typeof snapbackTime !== 'number' || !this.allowSnapback()) {
            snapbackTime = currentAdvertisement.end;
            snapbackType = player_base_1.SeekType.CURRENT_TIME;
        }
        var seekOptions = {
            advertisementSnapback: true,
        };
        this.snapbackTime = undefined;
        this.player.seek(snapbackTime, snapbackType, seekOptions);
    };
    BaseSsaiManager.prototype.unload = function () {
        this.player.removeEventListener('loadedmetadata', this.onLoadedMetadata);
        this.player.removeEventListener('timeupdate', this.onTimeUpdate);
        this.player.removeEventListener('seeked', this.onSeeked);
        this.player.removeEventListener('pause', this.onPause);
        this.player.removeEventListener('play', this.onPlay);
        this.player.removeEventListener('mutedchanged', this.onMutedChanged);
        this.advertisements = [];
        this.currentIndex = -1;
        this.previousTime = -1;
    };
    BaseSsaiManager.prototype.shouldPostponeInitialSeek = function () {
        return false;
    };
    return BaseSsaiManager;
}(player_plugin_ads_1.AdsManager));
exports.BaseSsaiManager = BaseSsaiManager;
//# sourceMappingURL=index.js.map